import { format } from 'date-fns';
import { enGB, de } from 'date-fns/locale';
import type { Locale } from 'date-fns/locale';
import i18n from 'i18next';

const isBlank = (object: any) => {
  if (object == null) return true;
  if (typeof object === 'string') return object.trim().length === 0;
  if (typeof object === 'object')
    return Object.values(object).find((value) => value !== '' && value !== null) === undefined;
};

const isNotNullOrUndefined = (object: any) => {
  return !(object == null); // Don't touch the double equals here! (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#loose_equality_using)
};

const isNullOrUndefined = (object: any) => {
  return object == null; // Don't touch the double equals here! (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#loose_equality_using)
};

const getCustomFormattedDate = (date: string | null | undefined, formatString: string) => {
  let formatted = '';
  if (!date) return formatted;

  const locales: { [key: string]: Locale } = {
    en: enGB,
    de: de,
  };

  try {
    formatted = format(new Date(date), formatString, {
      locale: locales[i18n.language] ?? enGB,
    });
  } catch (error) {
    console.error(error);
  }
  return formatted;
};
const getFormattedDate = (date: string | null | undefined, short: boolean) => {
  return getCustomFormattedDate(date, short ? 'dd.MM.yyyy' : 'dd.MM.yyyy HH:mm:ss');
};

const shortText = (input: string, maxLength: number) => {
  return input.length > maxLength ? input.substring(0, maxLength - 3) + '...' : input;
};

const roundToPrecision = (number: number, precision = 2) => {
  const m = Math.pow(10, precision);
  return Math.round(number * m) / m;
};

const Helper = {
  isBlank,
  isNullOrUndefined,
  isNotNullOrUndefined,
  getFormattedDate,
  shortText,
  getCustomFormattedDate,
  roundToPrecision,
};

export default Helper;
